import axios from "axios";

export const adminAxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  timeout: 15000,
  headers: {
    Authorization: `Bearer ${process.env.REACT_APP_API_AUTHORIZATION_TOKEN}`,
  },
});

let adminAccessToken: string | null = null;

export const setAdminAccessToken = (token: string | null) => {
  adminAccessToken = token;

  if (token) {
    adminAxiosInstance.defaults.headers.common["x-authenticated-user"] = `Bearer ${token}`;
    return;
  }

  delete adminAxiosInstance.defaults.headers.common["x-authenticated-user"];
};

adminAxiosInstance.interceptors.request.use((config) => {
  if (adminAccessToken) {
    config.headers["x-authenticated-user"] = `Bearer ${adminAccessToken}`;
  } else {
    delete config.headers["x-authenticated-user"];
  }

  return config;
});
